import { getProfile } from './api';
import { profileKeys } from './keys';

export const profileQueryOptions = () => ({
  queryKey: profileKeys.profile(),
  queryFn: () => getProfile().then((res) => res.profile),
  staleTime: Infinity,
  gcTime: Infinity,
  retry: false,
});
